import React, { FC, ReactNode } from 'react';

import MenuSectionHeading from 'components/menu-section-heading';

export const TrendingHeader: FC<{ children: ReactNode }> = ({ children }) => (
  <MenuSectionHeading as="h2">{children}</MenuSectionHeading>
);
